import type { ComponentProps, FC } from "react";

import { cn } from "../../utils";
import { appLinkClassName } from "./app-nav-link";
import { AppNavLinkContent, type AppNavLinkContentProps } from "./app-nav-link-content";
import { AppNavTooltip } from "./app-nav-tooltip";

export type AppNavButtonProps = ComponentProps<"button"> & AppNavLinkContentProps & { tooltipHidden?: boolean };

export const AppNavButton: FC<AppNavButtonProps> = ({
  className,
  count,
  icon,
  iconClassName,
  label,
  isLoading,
  tooltipHidden,
  hasChildren,
  ...props
}) => (
  <AppNavTooltip label={label} hidden={tooltipHidden}>
    <button {...props} disabled={props.disabled || isLoading} className={cn(appLinkClassName, className)}>
      <AppNavLinkContent
        count={count}
        icon={icon}
        iconClassName={iconClassName}
        label={label}
        isLoading={isLoading}
        hasChildren={hasChildren}
      />
    </button>
  </AppNavTooltip>
);
